/**
 * @param {import('modules/squad/types').GetSquadProductsResp} existingData
 * @param {import('modules/squad/types').GetSquadProductsResp} newData
 */
const mergeMemberProductsUtil = (existingData, newData) => {
  existingData = existingData || {}
  return {
    ...newData,
    products: [
      ...(existingData.products || []),
      ...newData.products
    ]
  }
}

export default mergeMemberProductsUtil
